import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

import {
  BOOLEAN_AND,
  BOOLEAN_OR,
  BOOLEAN_NOT
} from '../../redux/constants';
import EditDetailsButton from './EditDetailsButton';
import { 
    KEYWORDS_DETAILS_SECTION_I18N_KEYS as MY_I18N_KEYS, 
    KEYWORDS_DETAILS_SECTION_I18N_PREFIX as MY_I18N_PREFIX 
  } from './constants/i18n/KeywordsDetailsSectioni18nConstants';
  import {
    KEYWORD_FILTERING_TOPIC_MODAL_STATE
} from '../constants/constants';

class KeywordsDetailSection extends Component {
    static propTypes = {
        topicData:        PropTypes.object.isRequired,
        changeModalState: PropTypes.func.isRequired
    };

  constructor(props) {
    super(props);
    this.state = {
        topicData: JSON.parse(JSON.stringify(props.topicData))
      };
  }

  getI18nAbsoluteKey(relativeKey) {
    return MY_I18N_PREFIX + "." + relativeKey;
  }

  getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
  }

  getRowHeaderName(keywordClauseDict, index) {
    if (keywordClauseDict.hasOwnProperty(BOOLEAN_NOT)) {
        return this.getI18nText(MY_I18N_KEYS.none_of_these_keywords);
    }
    if (keywordClauseDict.hasOwnProperty(BOOLEAN_OR)) {
        if (index !== 0) {
            return this.getI18nText(MY_I18N_KEYS.and_any_of_these_keywords);
        }
        else {
            return this.getI18nText(MY_I18N_KEYS.any_of_these_keywords);
        }
    }
  }

  changeModalStateToKeywordFilteringTopicModalState() {
    this.props.changeModalState(KEYWORD_FILTERING_TOPIC_MODAL_STATE);
  }

  render() {
    const { topicData } = this.state;
    
    return (
        <div className='modal-body data-summary-modal-body topic-modal-sub-section'>
            <div className='topic-modal-sub-section-header'>
                <i className="las la-comments" />
                <span>{this.getI18nText(MY_I18N_KEYS.keywords_details_section_title)}</span>
                <EditDetailsButton
                    onClick={() => this.changeModalStateToKeywordFilteringTopicModalState()}
                    isEditModeActive={false}
                    isLoading={false}
                />
            </div>
            {
                !topicData.keywordsJSON && (
                    <div className='no-keywords-message-container'>
                        <span className="no-keywords-message">{this.getI18nText(MY_I18N_KEYS.no_keywords_for_topic_message)}</span>
                    </div>
                )
            }
            {topicData.keywordsJSON && topicData.keywordsJSON[BOOLEAN_AND].map((keywordClauseDict, index) => (
                <div className="data-summary-row" key={JSON.stringify(keywordClauseDict)}>
                    <label className="col-header">{this.getRowHeaderName(keywordClauseDict, index)}</label>
                    <div className="col-cell uneditable-tags-outer-container">
                        <div className='uneditable-tags-inner-container'>
                            {keywordClauseDict[Object.keys(keywordClauseDict)[0]].length > 0 ?
                            keywordClauseDict[Object.keys(keywordClauseDict)[0]].map((keyword, _) => (
                            <div className="uneditable-tag-item" key={keyword}>
                                <span>{keyword}</span>
                            </div>
                            )) : <span>{this.getI18nText(MY_I18N_KEYS.no_keywords_in_section_default_text)}</span>}
                        </div>
                    </div>
                </div>
            ))}
            {
                topicData.keywordsJSON && (
                    <div className="data-summary-row">
                        <div className='col-header'>
                            <span>{this.getI18nText(MY_I18N_KEYS.earliest_historical_data_date)}</span>
                        </div>
                        <span className="col-cell">{topicData.earliestHistoricalDataDate}</span>
                    </div>
                )
            }
        </div>
    );
  }
}

export default KeywordsDetailSection;


// WEBPACK FOOTER //
// ./src/features/topics/components/edit-topic/KeywordsDetailsSection.js